import { siteName, siteSlogan, heroStats } from '@/mocks/homeData';

export default function Hero() {
  return (
    <section
      id="hero"
      className="relative w-full min-h-[580px] md:min-h-[620px] flex items-center overflow-hidden"
    >
      <div className="absolute inset-0 bg-gradient-to-br from-background-100 via-background-50 to-primary-50/30"></div>
      <div className="absolute top-0 right-0 w-[60%] h-full opacity-[0.06] pointer-events-none">
        <div className="w-full h-full bg-[radial-gradient(ellipse_at_top_right,_oklch(0.54_0.20_24)_0%,_transparent_70%)]"></div>
      </div>

      <div className="relative w-full px-4 md:px-6 py-16 md:py-20">
        <div className="max-w-7xl mx-auto flex flex-col lg:flex-row items-center gap-10 lg:gap-16">
          <div className="flex-1 w-full text-center lg:text-left">
            <span className="inline-block px-3 py-1 text-xs font-medium rounded-full bg-accent-100 text-accent-700 mb-4 whitespace-nowrap">
              全网最快吃瓜平台
            </span>

            <h1 className="font-heading text-3xl md:text-5xl lg:text-[2.75rem] leading-tight text-foreground-900 mb-3">
              {siteName}
              <span className="block text-primary-600 text-2xl md:text-4xl lg:text-[2.25rem] mt-2">
                吃瓜第一手 爆料天天有
              </span>
            </h1>

            <p className="text-sm md:text-base text-foreground-600 leading-relaxed max-w-xl mx-auto lg:mx-0 mb-8">
              {siteName}是国内领先的娱乐八卦资讯聚合平台，全天候实时追踪明星恋情、综艺翻车、剧组路透、网红事件、选秀黑幕、直播带货等热门爆料。
              我们坚持多渠道交叉验证，每条信息标注来源与可信度评级，让吃瓜群众在第一时间获取最真实、最劲爆的今日爆料内容。
              百万瓜友在线互动，每日更新200+条新鲜内容，做你永远值得信赖的吃瓜第一站。
            </p>

            <div className="flex flex-wrap items-center justify-center lg:justify-start gap-6 md:gap-10 mb-8">
              {heroStats.map((stat) => (
                <div key={stat.label} className="text-center">
                  <div className="font-heading text-2xl md:text-3xl text-primary-600">
                    {stat.value}
                  </div>
                  <div className="text-xs text-foreground-500 mt-1">{stat.label}</div>
                </div>
              ))}
            </div>

            <div className="flex flex-col sm:flex-row items-center justify-center lg:justify-start gap-3">
              <a
                href="#cards"
                onClick={(e) => {
                  e.preventDefault();
                  document.querySelector('#cards')?.scrollIntoView({ behavior: 'smooth' });
                }}
                className="inline-flex items-center gap-2 px-6 py-3 bg-primary-500 text-background-50 rounded-lg font-medium text-sm hover:bg-primary-600 transition-colors duration-200 whitespace-nowrap cursor-pointer"
              >
                <i className="ri-fire-line"></i>
                立即吃瓜
              </a>
              <a
                href="#updates"
                onClick={(e) => {
                  e.preventDefault();
                  document.querySelector('#updates')?.scrollIntoView({ behavior: 'smooth' });
                }}
                className="inline-flex items-center gap-2 px-6 py-3 bg-secondary-100 text-secondary-800 rounded-lg font-medium text-sm hover:bg-secondary-200 transition-colors duration-200 whitespace-nowrap cursor-pointer"
              >
                <i className="ri-timer-flash-line"></i>
                查看最新快讯
              </a>
            </div>
          </div>

          <div className="flex-1 w-full max-w-[520px] lg:max-w-none">
            <div className="relative w-full aspect-[4/3] rounded-2xl overflow-hidden bg-background-200">
              <img
                src="https://readdy.ai/api/search-image?query=Dramatic%20entertainment%20news%20studio%20background%20with%20warm%20red%20and%20gold%20ambient%20lighting%2C%20abstract%20microphone%20and%20camera%20lens%20elements%2C%20modern%20Chinese%20digital%20media%20aesthetic%2C%20dark%20atmospheric%20background%20with%20soft%20spotlight%20glow%2C%20editorial%20photography%20style%20with%20cinematic%20composition%20and%20subtle%20bokeh%2C%20professional%20broadcast%20atmosphere%2C%20rich%20deep%20reds%20and%20warm%20amber%20tones&width=800&height=600&seq=hero-main-visual&orientation=landscape"
                alt={`${siteName} - 娱乐八卦爆料平台`}
                className="w-full h-full object-cover object-top"
                onError={(e) => {
                  const target = e.currentTarget;
                  target.style.display = 'none';
                  if (target.parentElement) {
                    target.parentElement.style.display = 'none';
                  }
                }}
              />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}